/** Post-calibration UI window (seconds). Compare wall times via UTC ms — timezone-agnostic. */
export const CALIBRATION_COUNTDOWN_SECONDS = 300;

/**
 * Remaining seconds in the calibration countdown window.
 * Only counts down when pendingCalibration is false and calibrationRequestedAt is valid.
 * remainderSec = 300 - floor((Date.now() - requestedAtMs) / 1000)
 */
export function getCalibrationSecondsLeft(
  pendingCalibration,
  calibrationRequestedAt,
  nowMs = Date.now()
) {
  if (pendingCalibration) return 0;
  const requestedAtMs =
    calibrationRequestedAt != null ? new Date(calibrationRequestedAt).getTime() : NaN;
  if (!Number.isFinite(requestedAtMs)) return 0;
  const elapsedSec = Math.floor((nowMs - requestedAtMs) / 1000);
  return Math.max(0, CALIBRATION_COUNTDOWN_SECONDS - elapsedSec);
}
